/**
 * Helpers de oferta — convenções centralizadas.
 * 
 * Memorial: o padrão de nomenclatura de oferta foi estabelecido na Sessão 4.7
 * após observação do Eduardo. 91 de 93 ofertas já seguiam esse padrão na prática;
 * agora está formalizado como REGRA do sistema.
 */

/**
 * Gera nome padronizado de oferta a partir de empresa e área.
 * 
 * Padrão: "EMPRESA.empresa: AREA.nome"
 * 
 * Exemplos:
 *   gerarNomeOferta({empresa: "CONX"}, {nome: "043.042 Gama Lobo"})
 *     → "CONX: 043.042 Gama Lobo"
 *   gerarNomeOferta({empresa: "HSI"}, {nome: "083.103 Ruth Cardoso"})
 *     → "HSI: 083.103 Ruth Cardoso"
 * 
 * Fallbacks:
 *   - Se empresa sem nome: retorna só o nome da área
 *   - Se área sem nome: retorna só o nome da empresa
 *   - Se ambos ausentes: retorna string vazia
 * 
 * @param {{empresa?: string, company_name?: string}} empresa
 * @param {{nome?: string}} area
 * @returns {string}
 */
export const gerarNomeOferta = (empresa, area) => {
  const nomeEmpresa = (empresa?.empresa || empresa?.company_name || '').trim();
  const nomeArea = (area?.nome || '').trim();
  
  if (nomeEmpresa && nomeArea) return `${nomeEmpresa}: ${nomeArea}`;
  if (nomeEmpresa) return nomeEmpresa;
  if (nomeArea) return nomeArea;
  return '';
};

/**
 * Verifica se um nome de oferta segue o padrão estabelecido.
 * Útil para avisos/lint em formulários.
 * 
 * @param {string} nome
 * @returns {boolean}
 */
export const nomeOfertaSegueConvencao = (nome) => {
  if (!nome || typeof nome !== 'string') return false;
  return nome.includes(': ');
};
